import { Injectable } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated = await this.authService.isAuthenticated();
    const isAdmin = await this.authService.isAdmin();

    if (isAuthenticated && isAdmin) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  async canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}

@Injectable({
  providedIn: 'root'
})
export class AdminOrValuationAdminGuard {
  constructor(private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const isAuthenticated = await this.authService.isAuthenticated();
    const isAdmin = await this.authService.isAdmin();
    const isValuationAdmin = await this.authService.isValuationAdmin();

    if (isAuthenticated && (isAdmin || isValuationAdmin)) {
      return true;
    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

  async canActivateChild(): Promise<boolean> {
    return this.canActivate();
  }
}

export const adminGuard: CanActivateFn = () => inject(AdminGuard).canActivate();
export const adminChildGuard: CanActivateChildFn = () => inject(AdminGuard).canActivateChild();

export const adminOrValuationAdminGuard: CanActivateFn = () => inject(AdminOrValuationAdminGuard).canActivate();
export const adminOrValuationAdminChildGuard: CanActivateChildFn = () => inject(AdminOrValuationAdminGuard).canActivateChild();